import { ICON_TYPES } from './iconTypes';

export default {
	reset: {
		name: 'sync',
		type: ICON_TYPES.ionicon,
		text: 'Reset'
	},
	play: {
		name: 'play',
		type: ICON_TYPES.ionicon,
		text: 'Play'
	},
	pause: {
		name: 'pause',
		type: ICON_TYPES.ionicon,
		text: 'Pause'
	},
	volumeMute: {
		name: 'volume-mute',
		type: ICON_TYPES.ionicon,
		text: 'Mute'
	},
	volumeUnmute: {
		name: 'volume-high',
		type: ICON_TYPES.ionicon,
		text: 'Unmute'
	},
	grabber: {
		name: 'barcode',
		type: ICON_TYPES.ionicon,
		text: 'Grabber'
	},

};